module.exports = __webpack_public_path__ + "img/up-arrow.d611b5e9.gif";